// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 1 miest
// VyuctovanieRD.jsx — DODACÍ LIST / VYÚČTOVANIE RD (Mirko GO 6.8.2026; rozšírené 10.8.):
// Pravidlá (ústava 122): len segment RD · VŠETKO editovateľné · DPH voliteľné · krok späť aj office ·
// archív = sken protokolu · PDF/pätička = výhradne KAMIR letterhead (backend).
// 10.8. „zaradom vsetko": odoslanie = ŠTANDARD (SendCustomerDialog 103.K) · údaje zákazníka Z CP ·
// priloha „protokol zo stavby" (ak nahratý) · história odoslaní (kto/komu/kedy/protokol) ·
// ľavý stĺpec so stavom odoslania · chrbtica (Dopyt / CP / Rozpis) klikacie.
import HelpHint from '../components/HelpHint.jsx'   // hinty_v1: obrazovka nemala ani jednu nápovedu
import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { fetchAuth, fetchAuthJSON } from '../auth/fetchAuth.js'
import { Btn, BtnAdd, BtnNav, BtnGhost, BtnDanger } from '../components/Btn.jsx'
import { Modal } from '../components/Modal.jsx'
import { useToast } from '../components/Toast.jsx'
import SendCustomerDialog from '../components/SendCustomerDialog.jsx'
import { COLORS, TYPO, SPACE, RADIUS, SK } from '../theme.js'   // CAS_ODOSLANIA_V1
import { usePinGate } from '../hooks/usePinGate.jsx'   // 122.7
import AttachmentsPanel from '../components/AttachmentsPanel.jsx'   // prilohy_nahradit_v1

const num = (v) => { const n = parseFloat(String(v ?? '').replace(',', '.')); return isNaN(n) ? 0 : n }
const eur = (n) => (Math.round(n * 100) / 100).toLocaleString('sk-SK', { minimumFractionDigits: 2 }) + ' €'
const STAV = { koncept: ['Koncept', '#b45309'], odoslany: ['Odoslaný zákazníkovi', '#1d4ed8'], schvaleny: ['Schválený — fakturuj', '#15803d'] }
const dtDT = (s) => String(s || '').slice(0, 16)
const dtD = (s) => { const a = String(s || '').slice(0, 10).split('-'); return a.length === 3 ? a[2] + '.' + a[1] + '.' : '' }

export default function VyuctovanieRD({ project, onClose }) {
  const toast = useToast()
  const navigate = useNavigate()
  const [list, setList] = useState([])
  const [dl, setDl] = useState(null)          // aktívny dodací list (editovaný, s detailom)
  const [items, setItems] = useState([])
  const [busy, setBusy] = useState(false)
  const [mailOpen, setMailOpen] = useState(false)
  const [partie, setPartie] = useState([])          // mzdy_vyuct_v1: číselník partií (kód + názov)
  const [suhrn, setSuhrn] = useState(null)          // mzdy_vyuct_v1: čo pôjde do mzdy — súhrn pred odoslaním (12.0 bod 3)
  // mzdy_vyuct_v2 (Mirko 8. 10. 2026): „office vyberie zaškrtnutím, ktoré polia im reálne patria."
  // Držíme kľúče riadkov, ktoré do mzdy NEJDÚ. Prázdne = idú všetky (predvolene sa nič nemení).
  const [vyn, setVyn] = useState(() => new Set())
  // POKLADNA_ZAKAZKA_V1 (Mirko 20. 10. 2026: „ak RD musí mať zákazku čislo aby ked pozriem vyuctovanie klikne prehodí ma tam a ukaze navzájaom prepojene“):
  // RD vklady zákazky z Pokladne a vklady bez zákazky, ktoré k nej sedia — len čítanie; priraďuje office v Pokladni.
  const [rdPokl, setRdPokl] = useState(null)
  useEffect(() => { fetchAuth('/api/pokladna/pre-zakazku/' + encodeURIComponent(project.id)).then(r => r.ok ? r.json() : null).then(setRdPokl).catch(() => setRdPokl(null)) }, [project.id])
  const prepniRiadok = (bid) => setVyn(s => { const n = new Set(s); if (n.has(bid)) n.delete(bid); else n.add(bid); return n })
  const [attachProtocol, setAttachProtocol] = useState(false)
  const [brana, setBrana] = useState(null)   // 122.7: čo chýba pred vyúčtovaním
  const pinGate = usePinGate()
  const fileRef = useRef(null)
  // vyuct_v1 (Mirko 2. 10. 2026: „do vyúčtovania keď pridám položku, vtedy sa musí automaticky ukladať“)
  // Doklad v koncepte sa ukladá sám — pridaná položka hneď, písanie po krátkej odmlke. Odoslaný a schválený
  // doklad sa nedotýka. Tlačidlo Uložiť ostáva na vedomé uloženie.
  const [autoStav, setAutoStav] = useState('')      // '' | 'zmenene' | 'ukladam' | 'ulozene HH:MM' | 'chyba' | 'konflikt'
  const posledneUlozene = useRef(null)              // telo, ktoré na serveri UŽ je
  const verzia = useRef(null)                       // updated_at, ktoré sme naposledy videli — proti prepísaniu cudzej práce
  const autoTimer = useRef(null)
  const hned = useRef(false)                        // pridanie položky sa ukladá bez odkladu
  const cerstvo = useRef(false)                     // práve načítané zo servera — nie je čo ukladať
  const bezi = useRef(false)                        // práve beží uloženie — druhé sa nepustí, počká
  const caka = useRef(false)                        // kým bežalo, pribudla ďalšia zmena
  const stop = useRef(false)                        // konflikt alebo chyba — automat sa zastaví, kým človek nerozhodne
  const zatvaram = useRef(false)                    // Esc aj klik mimo okna vedia spustiť zatvorenie dvakrát
  const dlRef = useRef(null); dlRef.current = dl
  const itemsRef = useRef([]); itemsRef.current = items

  const load = async () => {
    const rows = await fetchAuthJSON('/api/dodacie-listy/project/' + project.id).catch(() => [])
    setList(Array.isArray(rows) ? rows : [])
    return rows
  }
  useEffect(() => { load().then(rows => { if (rows && rows[0]) openDl(rows[0]) }) }, [project.id])

  // vyuct_v1: automat. Pridaná položka sa uloží hneď, prepisovanie po 900 ms ticha. Odoslaný doklad sa nemení.
  useEffect(() => {
    if (!dl || !dl.id || dl.stav !== 'koncept') return undefined
    const teraz = JSON.stringify(telo(dl, items))
    if (cerstvo.current) { cerstvo.current = false; posledneUlozene.current = teraz; return undefined }
    if (posledneUlozene.current === null) { posledneUlozene.current = teraz; return undefined }
    if (teraz === posledneUlozene.current) return undefined
    setAutoStav('zmenene')
    const odklad = hned.current ? 0 : 900; hned.current = false
    if (autoTimer.current) clearTimeout(autoTimer.current)
    autoTimer.current = setTimeout(() => ulozTiche(dlRef.current, itemsRef.current), odklad)
    return () => { if (autoTimer.current) clearTimeout(autoTimer.current) }
  }, [items, dl])

  // Zatvorenie okna: najprv dolož, čo ešte nie je na serveri, a POČKAJ na to. Rozpísaná položka sa nesmie stratiť
  // ani vtedy, keď office zavrie okno do 900 ms po písaní (HLAVNÁ 2. 10.: táto obrazovka nemá ani stráž odchodu).
  const doPokladne = async (url) => {   // POKLADNA_ZAKAZKA_V1: najprv uloží rozpísané vyúčtovanie, potom preklik
    if (zatvaram.current) return
    zatvaram.current = true
    try {
      const hotovo = await dolozRozpisane()
      if (!hotovo) { toast.error('Najprv sa musí uložiť rozpísané vyúčtovanie. Skús Uložiť.'); return }
      onClose(); navigate(url)
    } finally { zatvaram.current = false }
  }
  const dolozAZavri = async () => {
    if (zatvaram.current) return
    zatvaram.current = true
    try {
      const hotovo = await dolozRozpisane()
      if (!hotovo) {
        // uloženie zlyhalo alebo doklad medzitým zmenil niekto iný — okno ostáva otvorené, prácu nestratíš
        toast.error('Nezavieram — posledná zmena nie je uložená. Skús Uložiť, alebo si doklad načítaj znova.')
        return
      }
      onClose()
    } finally { zatvaram.current = false }
  }
  // Posledná poistka. Pri odmontovaní komponentu React úklid beží, pri zatvorení karty, F5 alebo spadnutí
  // prehliadača NIE — preto aj beforeunload. keepalive drží požiadavku živú aj po zavretí karty.
  const posliNaslepo = () => {
    const d = dlRef.current
    if (!d || !d.id || d.stav !== 'koncept' || posledneUlozene.current === null || stop.current) return
    const teraz = JSON.stringify(telo(d, itemsRef.current))
    if (teraz === posledneUlozene.current) return
    try {
      fetchAuth('/api/dodacie-listy/' + d.id, {
        method: 'PUT', keepalive: true,
        body: JSON.stringify({ ...telo(d, itemsRef.current), tiche: true, updated_at: verzia.current }),
      }).catch(() => {})
    } catch (_) {}
  }
  useEffect(() => {
    const f = () => posliNaslepo()
    window.addEventListener('beforeunload', f)
    return () => {
      window.removeEventListener('beforeunload', f)
      if (autoTimer.current) clearTimeout(autoTimer.current)
      posliNaslepo()
    }
  }, [])

  // detail (send_defaults / chrbtica / odoslania) chodí len z GET /:id
  const openDl = async (r) => {
    // prepnutie na iný doklad nesmie zahodiť rozpísané — najprv dolož, potom prepíš obrazovku
    await dolozRozpisane()
    const full = await fetchAuthJSON('/api/dodacie-listy/' + r.id).catch(() => r)
    const zoznam = JSON.parse((full && full.polozky_json) || '[]')
    cerstvo.current = true; stop.current = false; caka.current = false; setAutoStav('')
    verzia.current = (full && full.updated_at) || null
    setDl(full); setItems(zoznam)
  }

  const vytvor = async (pinAuditId) => {
    setBusy(true)
    try {
      const r = await fetchAuth('/api/dodacie-listy', { method: 'POST', headers: pinAuditId ? { 'X-Pin-Audit-Id': String(pinAuditId) } : {}, body: JSON.stringify({ project_id: project.id }) })
      const j = await r.json()
      if (!r.ok && j.kod === 'NAKLADY_NEPOTVRDENE') { setBrana(j); return }
      if (!r.ok) throw new Error(j.error || 'Nepodarilo sa vytvoriť.')
      setBrana(null)
      toast.success('Dodací list ' + j.id + ' založený — polia sú predvyplnené, všetko môžeš upraviť.')
      await load(); await openDl(j)
    } catch (e) { toast.error(e.message) } finally { setBusy(false) }
  }

  // dolož, čo ešte nie je na serveri; vráti true, keď je po ňom všetko uložené
  const dolozRozpisane = async () => {
    if (autoTimer.current) { clearTimeout(autoTimer.current); autoTimer.current = null }
    const d = dlRef.current
    if (!d || !d.id || d.stav !== 'koncept' || posledneUlozene.current === null) return true
    if (stop.current) return false
    const teraz = JSON.stringify(telo(d, itemsRef.current))
    if (teraz === posledneUlozene.current) return true
    return await ulozTiche(d, itemsRef.current)
  }

  const telo = (d, zoznam) => ({
    datum: d.datum, stavba: d.stavba, objednavatel: d.objednavatel, poznamka: d.poznamka || '',
    vat_rate: d.vat_rate === '' || d.vat_rate == null ? null : num(d.vat_rate), polozky: zoznam,
    zlava_typ: d.zlava_typ || 'pct', zlava_hodnota: num(d.zlava_hodnota),
  })

  const uloz = async (tiche) => {
    if (!dl) return false
    const t = telo(dl, items)
    const r = await fetchAuth('/api/dodacie-listy/' + dl.id, { method: 'PUT', body: JSON.stringify({ ...t, updated_at: verzia.current }) })
    const j = await r.json()
    if (r.status === 409) { stop.current = true; setAutoStav('konflikt'); toast.error(j.error || 'Doklad medzitým zmenil niekto iný — načítaj si ho znova.'); return false }
    if (!r.ok) { toast.error(j.error || 'Uloženie zlyhalo.'); return false }
    posledneUlozene.current = JSON.stringify(t)
    if (j && j.updated_at) verzia.current = j.updated_at
    if (!tiche) toast.success('Dodací list uložený.')
    await openDl({ id: dl.id }); load()   // refresh detail (nestrať send_defaults/chrbtica)
    return true
  }

  // Tiché uloženie: BEZ obnovenia detailu, aby rozpísané pole nezmizlo pod rukami. Vracia true/false — volajúci
  // musí vedieť, či sa to naozaj zapísalo (inak by sa okno zavrelo nad stratenou prácou).
  // Dve uloženia naraz nebežia: kým jedno letí, druhé počká a potom pošle NAJNOVŠÍ stav, nie ten svoj starý.
  const ulozTiche = async (d, zoznam) => {
    if (!d || !d.id || d.stav !== 'koncept' || stop.current) return false
    if (bezi.current) { caka.current = true; return false }
    bezi.current = true
    const t = telo(d, zoznam); const telojs = JSON.stringify(t)
    setAutoStav('ukladam')
    try {
      const r = await fetchAuth('/api/dodacie-listy/' + d.id, { method: 'PUT', body: JSON.stringify({ ...t, tiche: true, updated_at: verzia.current }) })
      if (r.status === 409) {
        const j = await r.json().catch(() => ({}))
        stop.current = true; setAutoStav('konflikt')
        toast.error(j.error || 'Doklad medzitým zmenil niekto iný — načítaj si ho znova.')
        return false
      }
      if (!r.ok) {
        const j = await r.json().catch(() => ({}))
        setAutoStav('chyba'); toast.error((j.error || 'Automatické uloženie zlyhalo') + ' — klikni Uložiť.')
        return false
      }
      const novy = await r.json().catch(() => null)
      if (novy && novy.updated_at) verzia.current = novy.updated_at
      posledneUlozene.current = telojs
      setAutoStav('ulozene ' + new Date().toLocaleTimeString('sk-SK', { hour: '2-digit', minute: '2-digit' }))
      return true
    } catch (e) {
      setAutoStav('chyba'); toast.error('Automatické uloženie zlyhalo: ' + (e && e.message ? e.message : '') + ' — klikni Uložiť.')
      return false
    } finally {
      bezi.current = false
      if (caka.current && !stop.current) { caka.current = false; setTimeout(() => ulozTiche(dlRef.current, itemsRef.current), 0) }
    }
  }

  const pdf = async () => {
    if (dl.stav === 'koncept' && !(await uloz(true))) return
    const r = await fetchAuth('/api/dodacie-listy/' + dl.id + '/pdf', { method: 'POST' })
    if (!r.ok) { toast.error('PDF sa nepodarilo vygenerovať.'); return }
    const url = URL.createObjectURL(await r.blob())
    window.open(url, '_blank')
  }

  // Odoslanie = ŠTANDARD (SendCustomerDialog); údaje sa predvyplnia z CP (dl.send_defaults)
  // mzdy_vyuct_v1: číselník partií pre stĺpec Partia (kód vidí aj zákazník, meno nikdy — 70.7)
  useEffect(() => { fetchAuth('/api/dodacie-listy/ciselnik/partie').then(r => r.ok ? r.json() : []).then(d => setPartie(Array.isArray(d) ? d : [])).catch(() => {}) }, [])

  // mzdy_vyuct_v1: pred odoslaním aj pred schválením ukáž, čo pôjde do mzdy, a nechaj office potvrdiť
  const otvorSuhrn = async (akcia) => {
    if (dl.stav === 'koncept' && !(await uloz(true))) return
    const r = await fetchAuth('/api/dodacie-listy/' + dl.id + '/mzda-nahlad')
    const j = await r.json().catch(() => null)
    if (!r.ok) { toast.error((j && j.error) || 'Súhrn sa nepodarilo načítať.'); return }
    // mzdy_vyuct_v2: zaškrtnutie prevezmeme z dokladu, nie z pamäte obrazovky — rozhodnutie drží doklad.
    const odskrtnute = new Set()
    for (const g of (j.skupiny || [])) for (const r of (g.riadky || [])) if (r.vybrane === false) odskrtnute.add(r.budget_item_id)
    setVyn(odskrtnute)
    setSuhrn({ ...j, akcia })
  }

  const posli = async () => {
    if (dl.stav === 'koncept' && !(await uloz(true))) return
    setAttachProtocol(false)
    setMailOpen(true)
  }

  const stav = async (s) => {
    const r = await fetchAuth('/api/dodacie-listy/' + dl.id + '/stav', { method: 'POST', body: JSON.stringify({ stav: s }) })
    const j = await r.json()
    if (!r.ok) { toast.error(j.error || 'Zmena stavu zlyhala.'); return }
    toast.success(s === 'koncept' ? 'Vrátené na koncept — môžeš upravovať (zapísané v audite).' : 'Stav: ' + STAV[s][0])
    const rows = await load(); const cur = (rows || []).find(x => x.id === dl.id); if (cur) await openDl(cur)
  }

  const nahraj = async (f) => {
    if (!f) return
    const fd = new FormData(); fd.append('file', f)
    const r = await fetchAuth('/api/dodacie-listy/' + dl.id + '/priloha', { method: 'POST', body: fd })
    const j = await r.json()
    if (!r.ok) { toast.error(j.error || 'Nahratie zlyhalo.'); return }
    toast.success('Protokol nahratý do archívu vyúčtovania.')
    const rows = await load(); const cur = (rows || []).find(x => x.id === dl.id); if (cur) await openDl(cur)
  }

  const setIt = (i, k, v) => setItems(arr => arr.map((x, ix) => ix === i ? { ...x, [k]: v } : x))
  const bez = items.reduce((a, p) => a + num(p.mnozstvo) * num(p.cena), 0)
  const zlava = dl && num(dl.zlava_hodnota) > 0 ? ((dl.zlava_typ || 'pct') === 'eur' ? num(dl.zlava_hodnota) : bez * num(dl.zlava_hodnota) / 100) : 0
  const poZlave = bez - zlava
  const sadzba = dl && dl.vat_rate != null && dl.vat_rate !== '' ? num(dl.vat_rate) : null
  const dph = sadzba != null ? poZlave * sadzba / 100 : 0
  const readOnly = dl && dl.stav !== 'koncept'
  const inp = { width: '100%', padding: '6px 8px', border: '1px solid ' + COLORS.line, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, fontFamily: 'inherit', boxSizing: 'border-box', background: readOnly ? '#f4f6f8' : '#fff' }
  const lbl = { fontSize: TYPO.sizes.xs, color: COLORS.muted, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 3 }
  const linkBtn = { border: '1px solid ' + COLORS.nav, color: COLORS.nav, background: COLORS.nav + '10', borderRadius: RADIUS.full, padding: '2px 10px', cursor: 'pointer', fontFamily: 'inherit', fontSize: TYPO.sizes.xs, fontWeight: 700 }
  const prilohy = dl ? JSON.parse(dl.prilohy_json || '[]') : []
  const odoslania = (dl && dl.odoslania) || []
  const chrb = (dl && dl.chrbtica) || {}
  const sd = (dl && dl.send_defaults) || {}

  return (
    <Modal open onClose={dolozAZavri} title={'Vyúčtovanie (dodací list) — ' + (project.name || project.id)} maxWidth={1040}>
      <div style={{ display: 'flex', gap: SPACE.md, maxHeight: '74vh' }}>

        {/* ── ĽAVÝ STĹPEC — zoznam vyúčtovaní so stavom odoslania ── */}
        <div style={{ width: 224, flexShrink: 0, borderRight: '1px solid ' + COLORS.line, paddingRight: SPACE.sm, overflow: 'auto', display: 'flex', flexDirection: 'column', gap: 6 }}>
          <div style={lbl}>Vyúčtovania</div>
          {list.map(r => {
            const active = dl && dl.id === r.id
            const sc = STAV[r.stav] || [r.stav, COLORS.muted]
            return (
              <button key={r.id} onClick={() => openDl(r)} style={{ textAlign: 'left', padding: '6px 8px', borderRadius: RADIUS.sm, cursor: 'pointer', fontFamily: 'inherit', border: '1px solid ' + (active ? COLORS.brand : COLORS.line), background: active ? COLORS.bg : '#fff' }}>
                <div style={{ fontWeight: 700, fontSize: TYPO.sizes.sm }}>{r.id}</div>
                <div style={{ fontSize: TYPO.sizes.xs, color: sc[1], fontWeight: 700 }}>{sc[0]}</div>
                <div style={{ fontSize: TYPO.sizes.xs, color: r.sent_at ? '#15803d' : '#b45309', marginTop: 2 }}>
                  {r.sent_at ? ('odoslané ' + SK.datumCas(r.sent_at) + (r.sent_to ? ' · ' + r.sent_to : '')) : 'neodoslané'}
                  {r.odoslania_count > 1 ? ' (' + r.odoslania_count + '×)' : ''}
                </div>
              </button>
            )
          })}
          <BtnAdd onClick={() => vytvor()} disabled={busy} style={{ marginTop: 6 }}>+ Nové vyúčtovanie</BtnAdd>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, lineHeight: 1.5, marginTop: 2 }}>Predvyplní z CP a poterového protokolu.</div>
        </div>

        {/* ── PRAVÝ STĹPEC — editor ── */}
        <div style={{ flex: 1, minWidth: 0, overflow: 'auto', display: 'flex', flexDirection: 'column', gap: SPACE.md, paddingRight: 4 }}>

          {dl && (<>
            {/* CHRBTICA — Zákazka · CP · Dopyt · Rozpis (klikacie) */}
            {(chrb.quote_number || chrb.dopyt_id || chrb.has_rozpis) && (
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', fontSize: TYPO.sizes.xs, background: '#f8fafc', border: '1px solid ' + COLORS.line, borderRadius: RADIUS.sm, padding: '6px 10px' }}>
                <span style={{ color: COLORS.muted, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em' }}>Chrbtica</span>
                <span style={{ color: '#334155' }}>Zákazka <b>{project.id}</b></span>
                {chrb.quote_number && <button title="Otvoriť cenovú ponuku" onClick={() => navigate('/cenove?open=' + encodeURIComponent(chrb.quote_number))} style={linkBtn}>CP {chrb.quote_number}</button>}
                {chrb.dopyt_id && <button title="Otvoriť dopyty" onClick={() => navigate('/dopyty')} style={linkBtn}>Dopyt #{chrb.dopyt_id}</button>}
                {chrb.has_rozpis > 0 && <button title="Otvoriť rozpis prác" onClick={() => navigate('/rozpis')} style={linkBtn}>Rozpis ({chrb.has_rozpis})</button>}
                {rdPokl && <button title="Otvoriť Pokladňu — pohyby tejto zákazky" onClick={() => doPokladne('/pokladna?zakazka=' + encodeURIComponent(project.id))} style={linkBtn}>Pokladňa ({rdPokl.vklady.length})</button>}
              </div>
            )}

            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
              <span style={{ padding: '3px 10px', borderRadius: RADIUS.full, fontSize: TYPO.sizes.xs, fontWeight: 800, color: STAV[dl.stav][1], border: '1px solid ' + STAV[dl.stav][1], background: STAV[dl.stav][1] + '12' }}>{STAV[dl.stav][0]}</span>
              <HelpHint section="122" text="ČO: vyúčtovanie hotového diela pre rodinný dom (dodací list) — riadky a ceny tak, ako ich zákazník uvidí na PDF; nový doklad sa predvyplní z cenovej ponuky a z nadspotreby poterového protokolu, prepísať, dopísať aj zmazať sa dá všetko. PREČO: RD nemá súpis prác, tento doklad ho zastupuje a zákazník má dielo skontrolovať pred faktúrou (ústava 122). KAM: koncept sa ukladá sám, odoslaný sa už needituje a „Vrátiť na koncept“ smie aj office (ide do auditu); pri odoslaní aj pri schválení sa riadky prepíšu do Výkazu výmer zákazky a zaškrtnuté riadky s partiou idú do mzdy tej partie bez sadzby — tú dopĺňa office v Mzdách. NEPATRÍ SEM mzdová sadzba partie ani faktúra či pohyb v pokladni: doklad nič nefakturuje a nič neplatí, je len podklad. Bez vybranej DPH je posledné číslo len Spolu a riadok SPOLU NA ÚHRADU sa vôbec nezobrazí; zoznam chýbajúcich nákladov je len pripomienka, vyúčtovanie nič neblokuje (122.7)." />   {/* hinty_v1 */}
              {dl.sent_at && <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>naposledy odoslané {SK.datumCas(dl.sent_at)} na {dl.sent_to}</span>}
              <span style={{ flex: 1 }} />
              {readOnly && <BtnGhost onClick={() => stav('koncept')} title="Krok späť — môže aj office, zapíše sa do auditu">← Vrátiť na koncept</BtnGhost>}
              {dl.stav === 'odoslany' && <Btn onClick={() => otvorSuhrn('schvaleny')}>Zákazník schválil ✓</Btn>}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.md }}>
              <div><div style={lbl}>Dátum</div><input type="date" style={inp} disabled={readOnly} value={dl.datum || ''} onChange={e => setDl({ ...dl, datum: e.target.value })} /></div>
              <div><div style={lbl}>Stavba</div><input style={inp} disabled={readOnly} value={dl.stavba || ''} onChange={e => setDl({ ...dl, stavba: e.target.value })} /></div>
              <div><div style={lbl}>DPH (voliteľné)</div>
                <select style={inp} disabled={readOnly} value={dl.vat_rate == null ? '' : String(dl.vat_rate)} onChange={e => setDl({ ...dl, vat_rate: e.target.value === '' ? null : e.target.value })}>
                  <option value="">bez DPH</option><option value="23">23 %</option><option value="19">19 %</option><option value="5">5 %</option>
                  {dl.vat_rate != null && !['23', '19', '5'].includes(String(dl.vat_rate)) && <option value={String(dl.vat_rate)}>{String(dl.vat_rate)} % (vlastná)</option>}
                </select></div>
            </div>
            <div style={{ display: 'flex', gap: SPACE.md, alignItems: 'flex-end' }}>
              <div style={{ width: 140 }}><div style={lbl}>Zľava na celkovú sumu</div>
                <input style={{ ...inp, textAlign: 'right' }} disabled={readOnly} value={dl.zlava_hodnota ?? ''} placeholder="0"
                  onChange={e => setDl({ ...dl, zlava_hodnota: e.target.value })} /></div>
              <div style={{ width: 90 }}>
                <select style={inp} disabled={readOnly} value={dl.zlava_typ || 'pct'} onChange={e => setDl({ ...dl, zlava_typ: e.target.value })}>
                  <option value="pct">%</option><option value="eur">€</option>
                </select></div>
              {zlava > 0 && <div style={{ fontSize: TYPO.sizes.sm, color: '#b45309', paddingBottom: 8 }}>−{eur(zlava)} → základ {eur(poZlave)}</div>}
            </div>
            <div><div style={lbl}>Objednávateľ (meno + adresa — na doklade)</div>
              <textarea style={{ ...inp, minHeight: 44 }} disabled={readOnly} value={dl.objednavatel || ''} onChange={e => setDl({ ...dl, objednavatel: e.target.value })} /></div>

            {/* POLOŽKY */}
            <div>
              <div style={{ ...lbl, marginBottom: 6 }}>Položky — všetko editovateľné, aj čisto vlastné</div>
              <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, background: '#f5f9fd', borderRadius: RADIUS.sm, padding: '6px 9px', marginBottom: 6 }}>
                Stĺpec <b>Partia</b> je interný — do dokladu pre zákazníka ide len jej <b>kód</b> (napr. PC2), meno nikdy. Riadky s partiou sa pri odoslaní dopíšu do jej mzdy;
                riadky bez partie (materiál, doprava) do mzdy nejdú. <b>Sadzbu tu nezadávaš</b> — cena na doklade je cena pre zákazníka, mzdu partie doplní office v Mzdách.
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
                <thead><tr>
                  {['Položka + popis', 'MJ', 'Množstvo', 'Jedn. cena €', 'Spolu', 'Partia (interné)', ''].map((h, i) => <th key={i} style={{ textAlign: i >= 2 && i <= 4 ? 'right' : 'left', padding: '4px 6px', borderBottom: '2px solid ' + COLORS.brand, fontSize: TYPO.sizes.xs, color: i === 5 ? '#0369a1' : COLORS.muted, background: i === 5 ? '#f5f9fd' : undefined }}>{h}</th>)}
                </tr></thead>
                <tbody>
                  {items.map((it, i) => (
                    <tr key={i} style={{ background: it.zdroj === 'nadspotreba' ? '#fff8f2' : it.zdroj === 'vlastna' ? '#f5f9f5' : '#fff' }}>
                      {/* vyuct_popis_v1 (Mirko 15. 10. 2026: „okienko položky musí byť širšie — nevidím zápis"):
                          stĺpec s položkou a popisom nemal minimálnu šírku, takže mu zostalo len to, čo zvýšilo
                          po piatich stĺpcoch s pevnou šírkou — a text sa orezal. */}
                      <td style={{ padding: '4px 6px', borderBottom: '1px solid ' + COLORS.line, minWidth: 300 }}>
                        <input style={inp} disabled={readOnly} value={it.title || ''} onChange={e => setIt(i, 'title', e.target.value)} placeholder="názov položky" />
                        <input style={{ ...inp, marginTop: 3, color: COLORS.text }} disabled={readOnly} value={it.popis || ''} onChange={e => setIt(i, 'popis', e.target.value)} placeholder="popis (voliteľný — vidí ho zákazník)" title={it.popis || ''} />
                      </td>
                      <td style={{ width: 52, padding: '4px 6px', borderBottom: '1px solid ' + COLORS.line }}><input style={inp} disabled={readOnly} value={it.mj || ''} onChange={e => setIt(i, 'mj', e.target.value)} /></td>
                      <td style={{ width: 78, padding: '4px 6px', borderBottom: '1px solid ' + COLORS.line }}><input style={{ ...inp, textAlign: 'right' }} disabled={readOnly} value={it.mnozstvo ?? ''} onChange={e => setIt(i, 'mnozstvo', e.target.value)} /></td>
                      <td style={{ width: 88, padding: '4px 6px', borderBottom: '1px solid ' + COLORS.line }}><input style={{ ...inp, textAlign: 'right' }} disabled={readOnly} value={it.cena ?? ''} onChange={e => setIt(i, 'cena', e.target.value)} /></td>
                      <td style={{ width: 96, padding: '4px 6px', borderBottom: '1px solid ' + COLORS.line, textAlign: 'right', fontWeight: 700, whiteSpace: 'nowrap' }}>{eur(num(it.mnozstvo) * num(it.cena))}</td>
                      <td style={{ width: 150, padding: '4px 6px', borderBottom: '1px solid ' + COLORS.line, background: '#f5f9fd' }}>
                        <select style={{ ...inp, color: it.partia ? '#0c4a6e' : COLORS.muted, fontWeight: it.partia ? 700 : 400 }} disabled={readOnly} value={it.partia || ''} onChange={e => setIt(i, 'partia', e.target.value)}
                          title="Ktorá partia to robila — riadok pôjde do jej mzdy. Zákazník uvidí len kód, nikdy meno. Prázdne = do mzdy nejde (materiál, doprava).">
                          <option value="">— bez partie —</option>
                          {partie.map(p => <option key={p.party_id} value={p.party_id}>{p.party_id} — {p.nazov}</option>)}
                        </select>
                      </td>
                      <td style={{ width: 34, padding: '4px 2px', borderBottom: '1px solid ' + COLORS.line, textAlign: 'center' }}>
                        {!readOnly && <button title="Odobrať položku" onClick={() => setItems(arr => arr.filter((_, ix) => ix !== i))} style={{ border: '1px solid #fca5a5', background: '#fef2f2', color: '#b91c1c', borderRadius: RADIUS.sm, cursor: 'pointer', padding: '2px 7px' }}>✕</button>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {!readOnly && <div style={{ display: 'flex', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
                <BtnGhost onClick={() => { hned.current = true; setItems(arr => [...arr, { title: '', popis: '', mj: 'm²', mnozstvo: '', cena: '', zdroj: 'vlastna' }]) }}>+ Pridať položku</BtnGhost>
                {partie.length > 0 && <select style={{ ...inp, width: 260 }} value="" title="Nastaví tú istú partiu všetkým riadkom naraz — Mirko 29. 9. 2026: bude na výber"
                  onChange={e => { const v = e.target.value; if (v !== '') { hned.current = true; setItems(arr => arr.map(x => ({ ...x, partia: v === '-' ? '' : v }))) } }}>
                  <option value="">Jedna partia na všetky riadky…</option>
                  <option value="-">— bez partie —</option>
                  {partie.map(p => <option key={p.party_id} value={p.party_id}>{p.party_id} — {p.nazov}</option>)}
                </select>}
              </div>}
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <table style={{ fontSize: TYPO.sizes.sm, borderCollapse: 'collapse' }}><tbody>
                <tr><td style={{ padding: '2px 12px' }}>Spolu{sadzba != null ? ' bez DPH' : ''}</td><td style={{ textAlign: 'right', fontWeight: 800 }}>{eur(bez)}</td></tr>
                {zlava > 0 && <tr><td style={{ padding: '2px 12px' }}>Zľava{(dl.zlava_typ || 'pct') === 'pct' ? ' ' + String(num(dl.zlava_hodnota)).replace('.', ',') + ' %' : ''}</td><td style={{ textAlign: 'right', color: '#b45309' }}>−{eur(zlava)}</td></tr>}
                {zlava > 0 && <tr><td style={{ padding: '2px 12px' }}>Základ po zľave</td><td style={{ textAlign: 'right', fontWeight: 800 }}>{eur(poZlave)}</td></tr>}
                {sadzba != null && <tr><td style={{ padding: '2px 12px' }}>DPH {String(sadzba).replace('.', ',')} %</td><td style={{ textAlign: 'right' }}>{eur(dph)}</td></tr>}
                {(sadzba != null || zlava > 0) && <tr><td style={{ padding: '4px 12px', borderTop: '2px solid #1a1a1a', fontWeight: 800 }}>SPOLU NA ÚHRADU</td><td style={{ textAlign: 'right', borderTop: '2px solid #1a1a1a', fontWeight: 800 }}>{eur(poZlave + dph)}</td></tr>}
              </tbody></table>
            </div>

            {rdPokl && (() => {   // POKLADNA_ZAKAZKA_V1 — RD vklady v Pokladni (11.8, nervová sústava 138)
              const tento = Math.round((poZlave + dph) * 100) / 100
              const fd = (d) => { const a = String(d || '').slice(0, 10).split('-'); return a.length === 3 ? Number(a[2]) + '. ' + Number(a[1]) + '. ' + a[0] : String(d || '') }
              const spolu = rdPokl.vklady.reduce((a, v) => a + Number(v.suma || 0), 0)
              const kDl = (v) => (rdPokl.vyuctovania || []).find(d => Math.abs(d.spolu - Number(v.suma)) <= 1)
              return (
                <div style={{ border: '1px solid ' + COLORS.line, borderRadius: RADIUS.md, padding: SPACE.sm, background: '#fff' }}>
                  <div style={{ ...lbl, marginBottom: 6 }}>RD vklady v Pokladni · prepojenie (ústava 11.8)</div>
                  {rdPokl.vklady.length === 0 && <div style={{ fontSize: TYPO.sizes.sm, color: '#b45309', marginBottom: 6 }}>Táto zákazka zatiaľ nemá v Pokladni RD vklad. Toto vyúčtovanie je na <b>{eur(tento)}</b>.</div>}
                  {rdPokl.vklady.map(v => { const d = kDl(v); return (
                    <div key={v.id} style={{ display: 'flex', gap: 10, alignItems: 'center', fontSize: TYPO.sizes.sm, padding: '3px 0', flexWrap: 'wrap', borderBottom: '1px solid ' + COLORS.lineSoft }}>
                      <span style={{ minWidth: 86 }}>{fd(v.datum)}</span>
                      <span style={{ fontFamily: TYPO.mono }}>{v.id}</span>
                      <span style={{ flex: 1, minWidth: 140 }}>{v.popis}</span>
                      <b style={{ color: '#15803d' }}>{eur(Number(v.suma))}</b>
                      <span style={{ fontSize: TYPO.sizes.xs, color: d ? (d.id === dl.id ? '#15803d' : COLORS.muted) : '#b45309' }}>{d ? (d.id === dl.id ? 'sedí s týmto vyúčtovaním' : 'k ' + d.id) : 'nesedí so žiadnym vyúčtovaním'}</span>
                      <button onClick={() => doPokladne('/pokladna?pk=' + encodeURIComponent(v.id))} style={linkBtn}>Otvoriť v Pokladni ›</button>
                    </div>) })}
                  {rdPokl.vklady.length > 0 && <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 4 }}>Vklady spolu {eur(spolu)} · vyúčtovania spolu {eur((rdPokl.vyuctovania || []).reduce((a, d) => a + d.spolu, 0))}</div>}
                  {rdPokl.kandidati.length > 0 && (
                    <div style={{ marginTop: 8, background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: RADIUS.sm, padding: '6px 10px' }}>
                      <div style={{ fontSize: TYPO.sizes.xs, fontWeight: 700, color: COLORS.nav, textTransform: 'uppercase', letterSpacing: '.04em' }}>V Pokladni je vklad bez zákazky, ktorý sedí — priradí office</div>
                      {rdPokl.kandidati.map(k => (
                        <div key={k.id} style={{ display: 'flex', gap: 10, alignItems: 'center', fontSize: TYPO.sizes.sm, padding: '3px 0', flexWrap: 'wrap' }}>
                          <span style={{ fontFamily: TYPO.mono }}>{k.id}</span><span>{fd(k.datum)}</span><span style={{ flex: 1, minWidth: 140 }}>{k.popis}</span>
                          <b style={{ color: '#15803d' }}>{eur(Number(k.suma))}</b><span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>podľa: {k.podla}</span>
                          <button onClick={() => doPokladne('/pokladna?pk=' + encodeURIComponent(k.id))} style={linkBtn}>Otvoriť v Pokladni a priradiť ›</button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )
            })()}

            <div><div style={lbl}>Poznámka na doklade (voliteľná)</div>
              <textarea style={{ ...inp, minHeight: 40 }} disabled={readOnly} value={dl.poznamka || ''} onChange={e => setDl({ ...dl, poznamka: e.target.value })} /></div>

            {/* HISTÓRIA ODOSLANÍ — kto/komu/kedy/protokol (Mirko 10.8.) */}
            {odoslania.length > 0 && (
              <div style={{ background: '#f0f7ff', border: '1px solid #bfdbfe', borderRadius: RADIUS.md, padding: SPACE.sm }}>
                <div style={{ ...lbl, marginBottom: 6 }}>História odoslaní zákazníkovi</div>
                {odoslania.map((o, i) => (
                  <div key={i} style={{ fontSize: TYPO.sizes.sm, marginBottom: 2 }}>
                    <span style={{ color: '#15803d', fontWeight: 700 }}>{dtDT(o.kedy)}</span> · {o.komu}
                    {o.cc ? ' · kópia ' + o.cc : ''}
                    {o.s_protokolom ? <span style={{ color: '#1d4ed8' }}> · aj protokol zo stavby</span> : ''}
                    <span style={{ color: COLORS.muted, fontSize: TYPO.sizes.xs }}> · {o.kto}</span>
                    {/* posta_v1 (Mirko 2. 10. 2026): „používateľ si musí byť istý, že bolo na 100 % odoslané" —
                        ukážeme potvrdenie poštového servera, nie len to, že Matrix klikol */}
                    {o.prevzal
                      ? <div style={{ fontSize: TYPO.sizes.xs, color: '#15803d' }}>Pošta zásielku prevzala{o.msg_id ? ' · č. ' + String(o.msg_id).replace(/^<|>$/g, '').slice(0, 28) : ''}</div>
                      : <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Odoslané ešte pred zavedením potvrdenia od pošty</div>}
                  </div>
                ))}
              </div>
            )}

            {/* ARCHÍV — sken podpísaného protokolu zo stavby */}
            <div style={{ background: '#f8fafc', border: '1px solid ' + COLORS.line, borderRadius: RADIUS.md, padding: SPACE.sm }}>
              <div style={{ ...lbl, marginBottom: 6 }}>Archív vyúčtovania — sken podpísaného protokolu zo stavby</div>
              {/* prilohy_nahradit_v1 (Mirko 19. 10. 2026): archív je v registri príloh — Nahradiť s dôvodom, staršie verzie ostávajú, do e-mailu idú len platné */}
              <AttachmentsPanel entityType="dodaci_list" entityId={dl.id} showPhase={false}
                onChanged={async () => { try { const r = await fetchAuth('/api/dodacie-listy/' + dl.id); const j = await r.json(); if (r.ok) setDl(cur => ({ ...cur, prilohy_json: j.prilohy_json })) } catch (_) {} }} />
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', borderTop: '1px solid ' + COLORS.line, paddingTop: SPACE.sm }}>
              <BtnGhost onClick={dolozAZavri}>Zavrieť</BtnGhost>
              <BtnNav onClick={pdf}>Náhľad PDF (letterhead)</BtnNav>
              {!readOnly && <span style={{ alignSelf: 'center', marginRight: 'auto', fontSize: TYPO.sizes.xs, color: autoStav === 'chyba' ? '#b91c1c' : COLORS.muted }}>
                {autoStav === 'ukladam' ? 'Ukladám…'
                  : autoStav === 'zmenene' ? 'Neuložené — ukladám o chvíľu'
                  : autoStav === 'konflikt' ? 'Doklad zmenil niekto iný — načítaj si ho znova'
                  : autoStav === 'chyba' ? 'Neuložené — klikni Uložiť'
                  : autoStav ? 'Uložené sám ' + autoStav.replace('ulozene ', '') : 'Ukladá sa samo'}
              </span>}
              {!readOnly && <Btn onClick={() => uloz(false)}>Uložiť</Btn>}
              {!readOnly && <BtnAdd onClick={() => otvorSuhrn('odoslat')} disabled={busy}>Odoslať zákazníkovi na schválenie</BtnAdd>}
            </div>
          </>)}

          {!dl && list.length === 0 && (
            <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, lineHeight: 1.6 }}>
              Zákazka zatiaľ nemá vyúčtovanie. „+ Nové vyúčtovanie" vľavo predvyplní položky z cenovej ponuky
              a nadspotrebu z poterového protokolu — všetko potom môžeš upraviť, dopísať vlastné riadky alebo všetko zmazať a písať od nuly.
            </div>
          )}
        </div>
      </div>

      <Modal open={!!brana} onClose={() => setBrana(null)} title="Vyúčtovanie ešte nejde" subtitle="Pred vyúčtovaním musia byť náklady doplnené a potvrdené (ústava 122.7)." width="min(560px, 95vw)"
        footer={<><Btn onClick={() => setBrana(null)}>Doplním</Btn><BtnDanger onClick={async () => { const g = await pinGate('vyuctovanie_bez_nakladov', { project_id: project.id, chyba: brana && brana.chyba }); if (g && g.ok) { setBrana(null); vytvor(g.audit_id) } }} disabled={busy}>Vyúčtovať aj tak — PIN admina / majiteľa</BtnDanger></>}>
        <ul style={{ margin: 0, paddingLeft: 18, fontSize: TYPO.sizes.sm, lineHeight: 1.6 }}>{(brana && brana.chyba || []).map((c, i) => <li key={i}>{c}</li>)}</ul>
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 8 }}>Doplň to v zákazke (Finančný prehľad › Náklady pred vyúčtovaním, karta Výdavky, zošit Mzdy 2026, karta Výmery) a klikni Potvrdiť náklady.</div>
      </Modal>
      {/* ── ODOSLANIE = ŠTANDARD 103.K (údaje z CP + voliteľne protokol zo stavby) ── */}
      {/* mzdy_vyuct_v1 — SÚHRN PRED ODOSLANÍM (12.0 bod 3: žiadna tichá automatika; mzda vzniká klikom na inej obrazovke) */}
      {suhrn && dl && (
        <Modal open onClose={() => setSuhrn(null)} title={'Čo sa stane — vyúčtovanie ' + dl.id} maxWidth={620}
          footer={<>
            <BtnGhost onClick={() => setSuhrn(null)}>Späť na úpravu</BtnGhost>
            <BtnAdd onClick={async () => {
              // mzdy_vyuct_v2: rozhodnutie office sa najprv uloží na doklad, až potom sa pokračuje.
              const r = await fetchAuth('/api/dodacie-listy/' + dl.id + '/mzda-vyber', { method: 'POST', body: JSON.stringify({ vynechane: [...vyn] }) })
              if (!r.ok) { const d = await r.json().catch(() => ({})); toast.error(d.error || 'Výber riadkov sa nepodarilo uložiť.'); return }
              const a = suhrn.akcia; setSuhrn(null); if (a === 'odoslat') posli(); else stav('schvaleny')
            }}>
              {suhrn.akcia === 'odoslat' ? 'Pokračovať na odoslanie' : 'Schváliť a zapísať do mzdy'}
            </BtnAdd>
          </>}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
            {/* vyuct_nic_v2 (8. 10. 2026): doklad odíde vždy. Toto je pripomienka, nie zákaz — preto už nie je červená. */}
            {suhrn.kontrola && suhrn.kontrola.chyba && suhrn.kontrola.chyba.length > 0 && (
              <div style={{ background: COLORS.bgSoft, border: '1px solid ' + COLORS.line, borderRadius: RADIUS.md, padding: SPACE.sm, fontSize: TYPO.sizes.sm, color: COLORS.muted }}>
                <b>Doklad odíde</b> — len pripomíname, že sa ešte dopĺňa: {suhrn.kontrola.chyba.map(x => x.nazov.toLowerCase()).join(', ')}. Doplň to vo Finančnom prehľade zákazky (ústava 122.7). Bez toho to ide len na PIN.
              </div>
            )}
            {suhrn.skupiny.length === 0
              ? <div style={{ background: COLORS.bgSoft, borderRadius: RADIUS.md, padding: SPACE.sm, fontSize: TYPO.sizes.sm, color: COLORS.muted }}>
                  Žiadny riadok nemá partiu — <b>do mzdy nepôjde nič</b>. Ak to má partia dostať zaplatené, vráť sa a vyber partiu pri jej riadkoch.
                </div>
              : suhrn.skupiny.map(g => (
                <div key={g.partia_kod} style={{ border: '1px solid ' + COLORS.line, borderRadius: RADIUS.md, padding: SPACE.sm }}>
                  <div style={{ fontSize: TYPO.sizes.sm, marginBottom: 6 }}>
                    Do mzdy partie <b style={{ color: '#0369a1' }}>{g.partia_kod}</b>{g.partia_nazov ? ' — ' + g.partia_nazov : ''}
                    {!g.zname && <span style={{ color: '#b91c1c', fontWeight: 700 }}> · taká partia v Matrixe nie je, riadky sa nezapíšu</span>}
                    {g.zname && (g.zaklada_sa
                      ? <span style={{ color: '#15803d' }}> · založí sa nový zápis</span>
                      : <span style={{ color: COLORS.muted }}> · do zápisu „{g.blok_nazov}“</span>)}
                  </div>
                  {/* mzdy_vyuct_v2: office zaškrtne, ktoré riadky partii naozaj patria. Odškrtnutý riadok zostáva
                      vidieť stlmený — nech je zrejmé, že sa naň vedome nevzťahuje nárok, nie že sa stratil. */}
                  {g.riadky.map((r, i) => {
                    const ide = !vyn.has(r.budget_item_id)
                    return (
                      <label key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: TYPO.sizes.sm, borderTop: '1px solid ' + COLORS.line, padding: '3px 0', cursor: 'pointer', opacity: ide ? 1 : 0.5 }}>
                        <input type="checkbox" checked={ide} onChange={() => prepniRiadok(r.budget_item_id)}
                          title="Zaškrtnuté = partia má na tento riadok nárok a pôjde jej do mzdy" />
                        <span style={{ flex: 1, textDecoration: ide ? 'none' : 'line-through' }}>{r.popis}</span>
                        <span style={{ width: 92, textAlign: 'right' }}>{String(r.vymera).replace('.', ',')} {r.mj}</span>
                        <span style={{ width: 118, textAlign: 'right', color: ide ? '#b45309' : COLORS.muted, fontWeight: ide ? 700 : 400 }}>{ide ? 'sadzbu doplní office' : 'nárok nemá'}</span>
                      </label>
                    )
                  })}
                </div>
              ))}
            {/* mzdy_vyuct_v2: človek musí vidieť číslo, ktoré z jeho zaškrtania vyšlo, skôr než klikne ďalej */}
            {suhrn.skupiny.length > 0 && (
              <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.text }}>
                Do mzdy pôjde <b>{suhrn.skupiny.reduce((a, g) => a + g.riadky.filter(r => !vyn.has(r.budget_item_id)).length, 0)}</b> z {suhrn.skupiny.reduce((a, g) => a + g.riadky.length, 0)} riadkov s partiou.
                {vyn.size > 0 && <span style={{ color: COLORS.muted }}> Odškrtnuté ({vyn.size}) do mzdy nejdú — zostanú len na doklade.</span>}
              </div>
            )}
            {suhrn.bez_partie.length > 0 && (
              <div style={{ background: COLORS.bgSoft, borderRadius: RADIUS.md, padding: SPACE.sm, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
                Do mzdy nejde ({suhrn.bez_partie.length}): {suhrn.bez_partie.join(' · ')} — sú bez partie, ostávajú len na doklade a vo výkaze výmer.
              </div>
            )}
            <div style={{ background: '#fffbeb', borderRadius: RADIUS.md, padding: SPACE.sm, fontSize: TYPO.sizes.xs, color: '#b45309' }}>
              Sadzba sa z dokladu nepreberá — cena na ňom je cena pre zákazníka, nie mzda partie (ústava 70.3). Riadky prídu do mzdy bez sadzby a office ju doplní v Mzdách.
              Ak doklad odošleš znova, riadky sa <b>nezdvoja</b> — nahradia sa tie, ktoré z neho už pochádzajú.
            </div>
          </div>
        </Modal>
      )}

      {mailOpen && dl && (
        <SendCustomerDialog open onClose={() => setMailOpen(false)}
          title={'Odoslať vyúčtovanie ' + dl.id + ' zákazníkovi'}
          initTo={sd.email || ''} initCc={sd.cc || ''} phone={sd.telefon || ''}
          initSubject={'Dodací list — vyúčtovanie diela · ' + (dl.stavba || project.id)}
          initText={'Dobrý deň,\n\nv prílohe posielame vyúčtovanie diela (dodací list). Prosíme Vás o kontrolu.\n\nĎakujeme.\nKAMIR s.r.o.'}
          attachmentName={dl.id + '.pdf'}
          attachmentNote={'vygeneruje sa z aktuálneho stavu vyúčtovania (KAMIR letterhead).'}
          smsLabel={'SMS, že mu bolo vyúčtovanie odoslané'}
          footNote={'Odošle sa z firemnej schránky, kópia ostane v odoslanej pošte. Údaje sú predvyplnené z cenovej ponuky.'}
          extraOption={
            <label style={{ fontSize: TYPO.sizes.sm, display: 'flex', alignItems: 'center', gap: 8, cursor: prilohy.length ? 'pointer' : 'not-allowed', padding: '8px 10px', background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: RADIUS.sm, opacity: prilohy.length ? 1 : 0.65 }}>
              <input type="checkbox" checked={attachProtocol} disabled={!prilohy.length} onChange={e => setAttachProtocol(e.target.checked)} />
              <span>Priložiť aj <b>protokol zo stavby</b>{prilohy.length ? ' (' + prilohy.length + ' ' + (prilohy.length === 1 ? 'súbor' : 'súbory') + ')' : ' — zatiaľ nič nenahraté'}</span>
            </label>
          }
          onSend={async ({ to, cc, subject, text }) => {
            const r = await fetchAuth('/api/dodacie-listy/' + dl.id + '/send', { method: 'POST', body: JSON.stringify({ email: to, cc, subject, text, attach_protocol: attachProtocol }) })
            const j = await r.json(); if (!r.ok) throw new Error(j.error || 'Odoslanie zlyhalo.')
            return { to: j.to, sms: j.sms }
          }}
          onSent={async () => { setMailOpen(false); const rows = await load(); const cur = (rows || []).find(x => x.id === dl.id); if (cur) await openDl(cur) }}
        />
      )}
    </Modal>
  )
}
